import store  from '../store'
import connect_api from '../connect/connect_api';
import notification from '../components/subcomponents/notification';

function remote_command(remote_command, callback) {
    connect_api.sPOST('/device/remote_command',remote_command,function(error, response){
        if (error) {
            console.log(error);
            notification.error(error.api_error.message);
            callback(error,false);
        } else {
            store.dispatch({
                type: 'REMOTE_COMMAND',
                data: response.api_data
            });
            callback(false,response.api_data);
        }
    });
}

function emit_system_event(params) {
    connect_api.sPOST('/device/emit_system_event',params,function(error, response){
        if (error) {
            console.log(error);
            notification.error(error.api_error.message);
            //callback(error,false);
        } else {
            notification.success('System event fired');
            store.dispatch({
                type: 'EMIT_SYSTEM_EVENT',
                data: response.api_data
            });
            //callback(false,response.api_data);
        }
    });
}

function modules_state(callback) {
    connect_api.sPOST('/device/modules_state',{},function(error, response){
        if (error) {
            console.log(error);
            callback(error,false);
        } else {
            store.dispatch({
                type: 'MODULES_STATE',
                data: response.api_data
            });
            callback(false,true);
        }
    });
}

function modules_log(callback) {
    connect_api.sPOST('/device/modules_log',{},function(error, response){
        if (error) {
            console.log(error);
            callback(error,false);
        } else {
            store.dispatch({
                type: 'MODULES_LOG',
                data: response.api_data
            });
            callback(false,true);
        }
    });
}

function alarm_log(callback) {
    connect_api.sPOST('/device/alarm_log',{},function(error, response){
        if (error) {
            console.log(error);
            callback(error,false);
        } else {
            store.dispatch({
                type: 'ALARM_LOG',
                data: response.api_data
            });
            callback(false,true);
        }
    });
}

function upload_fw(data,callback) {
    connect_api.sPOST('/upload_fw',data,function(error, response){
        if (error) {
            console.log(error);
            callback(error,false);
        } else {
            callback(false,true);
        }
    });
}

export default  {
    emit_system_event: emit_system_event,
    remote_command : remote_command,
    modules_state: modules_state,
    modules_log: modules_log,
    upload_fw: upload_fw,
    alarm_log: alarm_log
}